<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="!!data">
    <InputBasic
        v-model="data"
        :args="args"
        :db="db"
        :skipped="skipped"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "../../../helpers/questionLoadHelpers";

import QuestionBase from "../../../QuestionBase";
import InputBasic from "../../../inputs/InputBasic";

export default {
  name: 'RelationshipDuration',
  mixins: [questionLoadHelpers],
  components: {
    InputBasic,
    QuestionBase
  },
  props: {
    value: {
      type: String,
      required: false
    },

  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title:  'In what year did you meet your partner?',
        subTitle:  null,
        tip: null,
      },
      args: {
        placeholder: 'YYYY',
        label: 'Year: (yyyy):',
        type: 'text',
        skippable: false,
        required: true,
        inputClass: 'field-66'
      },
      db: {
        saveLocation: 'client_client',
        saveField: 'profileRelationshipDuration'
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>